<div class="row justify-content-center">
    <div class="col-md-12">
        <div class="card my-5">
            <div class="card-header">
                <h3 class="text-center">
                    WARNING
                </h3>
            </div>
            <div class="card-body">
                <div class="alert alert-primary fadein">
                    <strong><p>
                       This action is restricted.
                    </p>
                    <p>Please click <a href="{{startPage}}">here</a> to try again.</p>
                    </strong>
                </div>
            </div>
        </div>
    </div>
</div>